(function () {
  'use strict';

  var BUILD = 'V2.35-PDP1-2026-09-21';
  var SECTION_SELECTOR = '.product-section[data-mekhann-pdp-system="modular-v1"]';
  var LEGACY_LAMPSHADE_SELECTOR = '.product-section[data-product-template="lampshade"]:not([data-mekhann-pdp-system="modular-v1"])';

  if (window.__mekhannPdpV218Ready) return;
  window.__mekhannPdpV218Ready = true;
  window.__mekhannSiteServicesReady = true;
  document.documentElement.setAttribute('data-mekhann-site-services-build', BUILD);

  var noticeTimer;
  var noticeHideTimer;
  var lastAdvisorTrigger;
  var advisorScrollY = 0;
  var advisorScrollLocked = false;
  var previousBodyTop = '';

  function toArray(value) {
    return Array.prototype.slice.call(value || []);
  }

  function normaliseText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function measurementText(value) {
    return String(value || '')
      .replace(/\r/g, '')
      .split('\n')
      .map(function (line) { return normaliseText(line); })
      .filter(Boolean)
      .join('\n');
  }

  function excerptUnits(value) {
    var text = normaliseText(value);
    if (window.Intl && typeof window.Intl.Segmenter === 'function') {
      return Array.from(new window.Intl.Segmenter(undefined, { granularity: 'word' }).segment(text))
        .map(function (part) { return part.segment; });
    }
    if (/\s/.test(text)) return text.split(/(\s+)/).filter(Boolean);
    return Array.from(text);
  }

  function normaliseMultiline(value) {
    return String(value || '')
      .split(/\r?\n/)
      .map(function (line) { return normaliseText(line); })
      .filter(Boolean)
      .join('\n');
  }

  function dimensionsForSize(value, variantTitle) {
    var text = normaliseMultiline(value);
    var size = String(variantTitle || '').toLowerCase().indexOf('medium') !== -1 ? 'medium' :
      (String(variantTitle || '').toLowerCase().indexOf('large') !== -1 ? 'large' : '');
    if (!text || !size) return text;
    var lines = text.split('\n');
    var matched = lines.find(function (line) {
      return line.toLowerCase().indexOf(size) === 0;
    });
    if (matched) return matched;
    var expression = size === 'medium'
      ? /(medium\s*[—–:-].*?)(?=\s+large\s*[—–:-]|$)/i
      : /(large\s*[—–:-].*)$/i;
    var inlineMatch = text.replace(/\n/g, ' ').match(expression);
    return inlineMatch ? normaliseText(inlineMatch[1]) : text;
  }

  function setMultilineText(element, value) {
    element.replaceChildren();
    String(value || '').split('\n').forEach(function (line, index) {
      if (index) element.appendChild(document.createElement('br'));
      element.appendChild(document.createTextNode(line));
    });
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(String(value));
    return String(value).replace(/(["\\])/g, '\\$1');
  }

  function closeDialog(dialog) {
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
      dialog.dispatchEvent(new Event('close'));
    }
  }

  function lockAdvisorScroll() {
    if (advisorScrollLocked) return;
    advisorScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    previousBodyTop = document.body.style.top;
    document.documentElement.classList.add('mekhann-advisor-is-open');
    document.body.classList.add('mekhann-advisor-is-open');
    document.body.style.top = '-' + advisorScrollY + 'px';
    advisorScrollLocked = true;
  }

  function unlockAdvisorScroll() {
    if (!advisorScrollLocked) return;
    document.documentElement.classList.remove('mekhann-advisor-is-open');
    document.body.classList.remove('mekhann-advisor-is-open');
    document.body.style.top = previousBodyTop;
    window.scrollTo(0, advisorScrollY);
    advisorScrollLocked = false;
  }

  function setInput(dialog, selector, value) {
    var input = dialog.querySelector(selector);
    if (input) input.value = value || '';
  }

  function setAdvisorContext(dialog, trigger) {
    var productTitle = trigger && trigger.dataset.mekhannAdvisorProduct;
    var variantTitle = trigger && trigger.dataset.mekhannAdvisorVariant;
    var contextUrl = trigger && trigger.dataset.mekhannAdvisorUrl;
    setInput(dialog, '[data-mekhann-advisor-context-title]', productTitle || document.title);
    setInput(dialog, '[data-mekhann-advisor-context-url]', contextUrl || window.location.href);
    setInput(dialog, '[data-mekhann-advisor-product]', productTitle || '');
    setInput(dialog, '[data-mekhann-advisor-variant]', variantTitle || '');
  }

  function expandAdvisorForm(toggle, region, focusField) {
    if (!toggle || !region) return;
    region.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    if (focusField) {
      var firstField = region.querySelector('input:not([type="hidden"]), textarea');
      if (firstField) firstField.focus();
    }
  }

  function collapseAdvisorForm(toggle, region) {
    if (!toggle || !region) return;
    region.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
  }

  function initAdvisorHub() {
    var dialog = document.querySelector('[data-mekhann-advisor-dialog]');
    if (!dialog || dialog.dataset.mekhannV218Bound === 'true') return;
    dialog.dataset.mekhannV218Bound = 'true';

    var close = dialog.querySelector('[data-mekhann-advisor-close]');
    var formToggle = dialog.querySelector('[data-mekhann-advisor-form-toggle]');
    var formRegion = dialog.querySelector('[data-mekhann-advisor-form-region]');
    var hasFormResult = Boolean(dialog.querySelector('[data-mekhann-advisor-result]'));

    function openAdvisor(trigger) {
      lastAdvisorTrigger = trigger || null;
      setAdvisorContext(dialog, trigger);
      if (hasFormResult) expandAdvisorForm(formToggle, formRegion, false);
      else collapseAdvisorForm(formToggle, formRegion);
      lockAdvisorScroll();
      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      if (close) close.focus();
    }

    window.__mekhannAdvisorOpenV218 = openAdvisor;
    if (!window.__mekhannAdvisorDelegatedV218) {
      window.__mekhannAdvisorDelegatedV218 = true;
      document.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-mekhann-advisor-open]');
        if (!trigger) return;
        event.preventDefault();
        if (typeof window.__mekhannAdvisorOpenV218 === 'function') {
          window.__mekhannAdvisorOpenV218(trigger);
        }
      });
    }
    if (close) close.addEventListener('click', function () { closeDialog(dialog); });
    if (formToggle && formRegion) {
      formToggle.addEventListener('click', function () {
        if (formRegion.hidden) expandAdvisorForm(formToggle, formRegion, true);
        else {
          collapseAdvisorForm(formToggle, formRegion);
          formToggle.focus();
        }
      });
    }
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeDialog(dialog);
    });
    dialog.addEventListener('close', function () {
      unlockAdvisorScroll();
      if (lastAdvisorTrigger && document.contains(lastAdvisorTrigger)) lastAdvisorTrigger.focus();
    });
    if (hasFormResult) openAdvisor(null);
  }

  /*
   * Keep the shared Advisor context truthful on legacy/non-builder PDPs.
   * Modular PDPs are owned by PdpController and are deliberately excluded so
   * one variantChange event can never create two competing updates.
   */
  function bindLegacyAdvisor(section) {
    if (!section || section.matches(SECTION_SELECTOR) || section.mekhannLegacyAdvisorV218Handler) return;
    var handler = function (event) {
      var triggers = toArray(section.querySelectorAll('[data-mekhann-advisor-open]'));
      if (!triggers.length) return;
      var variant = event.detail && event.detail.variant;
      var masterSelect = section.querySelector('[data-product-select]');
      var variantId = variant && variant.id;
      var variantTitle = variant && variant.title;

      if (!variantId && masterSelect) variantId = masterSelect.value;
      if (!variantTitle || variantTitle === 'Default Title') {
        variantTitle = toArray(section.querySelectorAll('[data-variant-input]:checked'))
          .map(function (input) { return input.value; })
          .filter(Boolean)
          .join(' / ');
      }

      var productUrl = new URL(section.dataset.productUrl || window.location.pathname, window.location.origin);
      if (variantId) productUrl.searchParams.set('variant', variantId);
      triggers.forEach(function (trigger) {
        trigger.dataset.mekhannAdvisorVariant = variantTitle || 'Default';
        trigger.dataset.mekhannAdvisorUrl = productUrl.toString();
      });
    };

    section.addEventListener('variantChange', handler);
    section.mekhannLegacyAdvisorV218Handler = handler;
  }

  function unbindLegacyAdvisor(section) {
    if (!section || !section.mekhannLegacyAdvisorV218Handler) return;
    section.removeEventListener('variantChange', section.mekhannLegacyAdvisorV218Handler);
    section.mekhannLegacyAdvisorV218Handler = null;
  }

  function currentVariantForSection(section) {
    var select = section && section.querySelector('[data-product-select]');
    var id = select && select.value;
    var json = section && section.querySelector('[data-variant-json]');
    if (!id || !json) return id ? { id: id } : null;
    try {
      return JSON.parse(json.value || json.textContent).find(function (variant) {
        return String(variant.id) === String(id);
      }) || { id: id };
    } catch (error) {
      return { id: id };
    }
  }

  /*
   * The shared product snippets also render inside Featured product and modal
   * surfaces. Keep their V2.16 behavior alive without allowing any legacy
   * controller to bind inside the modular builder root.
   */
  function LegacyDescriptionController(wrapper) {
    this.wrapper = wrapper;
    this.content = wrapper.querySelector('[data-mekhann-product-description-content]');
    this.toggle = wrapper.querySelector('[data-mekhann-product-description-toggle]');
    this.moreLabel = wrapper.dataset.legacyMoreLabel || 'Read more';
    this.lessLabel = wrapper.dataset.legacyLessLabel || 'Read less';
    this.expanded = false;
    this.initialised = false;
    this.boundToggle = this.onToggle.bind(this);
    if (!this.content || !this.toggle) return;
    this.toggle.addEventListener('click', this.boundToggle);
    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(this.refresh.bind(this));
      this.resizeObserver.observe(this.wrapper);
    }
    this.refresh();
  }

  LegacyDescriptionController.prototype.setLabel = function (label) {
    var labelNode = this.toggle.querySelector('[data-mekhann-description-label]');
    var ellipsisNode = this.toggle.querySelector('[data-mekhann-description-ellipsis]');
    if (labelNode) labelNode.textContent = label;
    else this.toggle.textContent = label;
    if (ellipsisNode) ellipsisNode.hidden = true;
  };

  LegacyDescriptionController.prototype.refresh = function () {
    if (!this.content || !this.toggle || !this.wrapper.isConnected) return;
    var overflows = this.content.scrollHeight > 56;
    if (!overflows) {
      this.content.classList.remove('is-collapsed');
      this.toggle.hidden = true;
      this.toggle.setAttribute('aria-expanded', 'false');
      this.expanded = false;
      this.setLabel(this.moreLabel);
      this.initialised = true;
      return;
    }
    if (!this.initialised) this.expanded = false;
    this.content.classList.toggle('is-collapsed', !this.expanded);
    this.toggle.hidden = false;
    this.toggle.setAttribute('aria-expanded', this.expanded ? 'true' : 'false');
    this.setLabel(this.expanded ? this.lessLabel : this.moreLabel);
    this.initialised = true;
  };

  LegacyDescriptionController.prototype.onToggle = function () {
    this.expanded = !this.expanded;
    this.content.classList.toggle('is-collapsed', !this.expanded);
    this.toggle.setAttribute('aria-expanded', this.expanded ? 'true' : 'false');
    this.setLabel(this.expanded ? this.lessLabel : this.moreLabel);
  };

  LegacyDescriptionController.prototype.destroy = function () {
    if (this.resizeObserver) this.resizeObserver.disconnect();
    if (this.toggle) this.toggle.removeEventListener('click', this.boundToggle);
    if (this.content) this.content.classList.remove('is-collapsed');
    if (this.toggle) {
      this.toggle.hidden = true;
      this.toggle.setAttribute('aria-expanded', 'false');
      this.setLabel(this.moreLabel);
    }
    if (this.wrapper) this.wrapper.mekhannLegacyDescriptionV218Controller = null;
  };

  function LegacyStoreAvailabilityController(holder) {
    this.holder = holder;
    this.boundMutations = this.onMutations.bind(this);
    this.observer = window.MutationObserver ? new MutationObserver(this.boundMutations) : null;
    this.refresh();
    this.observe();
  }

  LegacyStoreAvailabilityController.prototype.observe = function () {
    if (this.observer && this.holder && this.holder.isConnected) {
      this.observer.observe(this.holder, { childList: true, subtree: true });
    }
  };

  LegacyStoreAvailabilityController.prototype.refresh = function () {
    var holder = this.holder;
    if (!holder || holder.dataset.mekhannStoreInlineReady === 'true') return;
    var summaryLink = holder.querySelector('.store-availability__small--link');
    var drawer = holder.querySelector('#StoreAvailabilityDrawer');
    var drawerContent = drawer && drawer.querySelector('.drawer__scrollable > div');
    if (!drawer || !drawerContent) return;

    if (this.observer) this.observer.disconnect();
    if (summaryLink) summaryLink.remove();
    var details = document.createElement('details');
    details.className = 'mekhann-store-availability-inline';
    var summary = document.createElement('summary');
    summary.textContent = 'Store details';
    var panel = document.createElement('div');
    panel.className = 'mekhann-store-availability-inline__panel';
    panel.appendChild(drawerContent.cloneNode(true));
    details.appendChild(summary);
    details.appendChild(panel);
    drawer.remove();
    holder.appendChild(details);
    holder.dataset.mekhannStoreInlineReady = 'true';
    this.observe();
  };

  LegacyStoreAvailabilityController.prototype.onMutations = function () {
    this.holder.dataset.mekhannStoreInlineReady = 'false';
    this.refresh();
  };

  LegacyStoreAvailabilityController.prototype.destroy = function () {
    if (this.observer) this.observer.disconnect();
    if (this.holder) this.holder.mekhannLegacyStoreV218Controller = null;
  };

  function LegacyLampshadeController(section) {
    this.section = section;
    this.descriptions = [];
    this.stores = [];
    this.refreshFrame = 0;
    this.boundVariantChange = this.onVariantChange.bind(this);
    this.boundMutations = this.queueRefresh.bind(this);
    section.addEventListener('variantChange', this.boundVariantChange);
    this.refresh();
    this.sectionObserver = window.MutationObserver ? new MutationObserver(this.boundMutations) : null;
    if (this.sectionObserver) this.sectionObserver.observe(section, { childList: true, subtree: true });
    this.onVariantChange({ detail: { variant: currentVariantForSection(section) } });
  }

  LegacyLampshadeController.prototype.refresh = function () {
    this.refreshFrame = 0;
    this.descriptions = this.descriptions.filter(function (controller) {
      if (controller.wrapper && this.section.contains(controller.wrapper)) return true;
      controller.destroy();
      return false;
    }, this);
    this.stores = this.stores.filter(function (controller) {
      if (controller.holder && this.section.contains(controller.holder)) return true;
      controller.destroy();
      return false;
    }, this);

    toArray(this.section.querySelectorAll('[data-mekhann-product-description]')).forEach(function (wrapper) {
      if (wrapper.mekhannLegacyDescriptionV218Controller) return;
      var controller = new LegacyDescriptionController(wrapper);
      if (!controller.content || !controller.toggle) return;
      wrapper.mekhannLegacyDescriptionV218Controller = controller;
      this.descriptions.push(controller);
    }, this);
    toArray(this.section.querySelectorAll('[data-store-availability-holder]')).forEach(function (holder) {
      if (holder.mekhannLegacyStoreV218Controller) return;
      var controller = new LegacyStoreAvailabilityController(holder);
      holder.mekhannLegacyStoreV218Controller = controller;
      this.stores.push(controller);
    }, this);
  };

  LegacyLampshadeController.prototype.queueRefresh = function () {
    if (this.refreshFrame) return;
    this.refreshFrame = window.requestAnimationFrame(this.refresh.bind(this));
  };

  LegacyLampshadeController.prototype.updateAssurance = function (variant) {
    toArray(this.section.querySelectorAll('[data-mekhann-dispatch]')).forEach(function (dispatch) {
      dispatch.hidden = !variant || variant.available === false;
    });
  };

  LegacyLampshadeController.prototype.updateDimensions = function (variant) {
    var variantId = variant && variant.id;
    toArray(this.section.querySelectorAll('[data-mekhann-lampshade-details]')).forEach(function (details) {
      var output = details.querySelector('[data-mekhann-selected-dimensions]');
      if (!output) return;
      var source = variantId && details.querySelector('[data-mekhann-variant-dimensions][data-variant-id="' + cssEscape(variantId) + '"]');
      var value = normaliseMultiline(source && source.textContent);
      value = value || normaliseMultiline(details.dataset.sharedDimensions || details.dataset.dimensionsFallback);
      setMultilineText(output, value);
      output.hidden = !value;
    });
  };

  LegacyLampshadeController.prototype.onVariantChange = function (event) {
    var hasVariantDetail = Boolean(event && event.detail &&
      Object.prototype.hasOwnProperty.call(event.detail, 'variant'));
    var variant = hasVariantDetail ? event.detail.variant : currentVariantForSection(this.section);
    this.updateAssurance(variant);
    this.updateDimensions(variant);
  };

  LegacyLampshadeController.prototype.destroy = function () {
    window.cancelAnimationFrame(this.refreshFrame);
    this.section.removeEventListener('variantChange', this.boundVariantChange);
    if (this.sectionObserver) this.sectionObserver.disconnect();
    this.descriptions.forEach(function (controller) { controller.destroy(); });
    this.stores.forEach(function (controller) { controller.destroy(); });
    this.descriptions = [];
    this.stores = [];
  };

  function initLegacyLampshadeSection(section) {
    if (!section || !section.matches(LEGACY_LAMPSHADE_SELECTOR)) return;
    if (section.mekhannLegacyLampshadeV218Controller) return;
    section.mekhannLegacyLampshadeV218Controller = new LegacyLampshadeController(section);
  }

  function descriptionSourceText(content) {
    if (!content) return '';
    if (!content.querySelector('[data-mekhann-sku]')) return content.innerText || content.textContent;
    // The original description can be display:none while its excerpt is shown.
    // Keep the real SKU in its own last paragraph, never flattened into the
    // 15px reading excerpt. Read a detached copy without revealing live IDs.
    var source = content.cloneNode(true);
    toArray(source.querySelectorAll('[hidden], [data-mekhann-sku]')).forEach(function (node) { node.remove(); });
    toArray(source.querySelectorAll('br')).forEach(function (node) {
      node.replaceWith(document.createTextNode('\n'));
    });
    toArray(source.querySelectorAll('p, div, li, h1, h2, h3, h4, h5, h6, blockquote, tr')).forEach(function (node) {
      node.appendChild(document.createTextNode('\n'));
    });
    return source.textContent;
  }

  function DescriptionController(wrapper) {
    this.wrapper = wrapper;
    this.content = wrapper.querySelector('[data-mekhann-product-description-content]');
    this.toggle = wrapper.querySelector('[data-mekhann-product-description-toggle]');
    this.lines = Math.max(1, parseInt(wrapper.dataset.collapsedLines || '2', 10) || 2);
    this.moreLabel = wrapper.dataset.moreLabel || (this.toggle && this.toggle.textContent.trim()) || 'See more';
    this.lessLabel = wrapper.dataset.lessLabel || 'See less';
    this.hasSku = Boolean(this.content && this.content.querySelector('[data-mekhann-sku]'));
    var sourceText = descriptionSourceText(this.content);
    this.fullText = normaliseText(sourceText);
    this.fullMeasureText = measurementText(sourceText);
    this.expanded = this.toggle && this.toggle.getAttribute('aria-expanded') === 'true';
    this.lastWidth = -1;
    this.resizeFrame = 0;
    this.excerpt = null;
    this.destroyed = false;
    this.previousContentDisplay = this.content ? this.content.style.getPropertyValue('display') : '';
    this.previousContentDisplayPriority = this.content ? this.content.style.getPropertyPriority('display') : '';
    this.boundToggle = this.onToggle.bind(this);
    this.boundResize = this.queueMeasure.bind(this);
    if (!this.content || !this.toggle || (!this.fullText && !this.hasSku)) return;
    this.toggle.addEventListener('click', this.boundToggle);
    window.addEventListener('resize', this.boundResize, { passive: true });
    if (window.ResizeObserver) {
      var self = this;
      this.resizeObserver = new ResizeObserver(function () {
        var width = Math.round(self.wrapper.getBoundingClientRect().width * 10) / 10;
        if (width !== self.lastWidth) self.queueMeasure();
      });
      this.resizeObserver.observe(this.wrapper);
    }
    this.measure();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { this.queueMeasure(); }.bind(this));
    }
  }

  DescriptionController.prototype.refreshSource = function () {
    if (this.destroyed || !this.hasSku) return;
    var sourceText = descriptionSourceText(this.content);
    this.fullText = normaliseText(sourceText);
    this.fullMeasureText = measurementText(sourceText);
    this.measure();
  };

  DescriptionController.prototype.showOriginal = function () {
    if (this.excerpt) {
      if (this.excerpt.contains(this.toggle)) this.wrapper.appendChild(this.toggle);
      this.excerpt.remove();
      this.excerpt = null;
    }
    this.content.hidden = false;
    if (this.previousContentDisplay) {
      this.content.style.setProperty('display', this.previousContentDisplay, this.previousContentDisplayPriority);
    } else {
      this.content.style.removeProperty('display');
    }
  };

  DescriptionController.prototype.hideOriginal = function () {
    this.content.hidden = true;
    this.content.style.setProperty('display', 'none', 'important');
  };

  DescriptionController.prototype.setToggleLabel = function (label) {
    var labelNode = this.toggle.querySelector('[data-mekhann-description-label]');
    var ellipsisNode = this.toggle.querySelector('[data-mekhann-description-ellipsis]');
    if (labelNode) labelNode.textContent = label;
    else this.toggle.textContent = label;
    if (ellipsisNode) ellipsisNode.hidden = true;
  };

  DescriptionController.prototype.makeProbe = function () {
    var probe = this.content.cloneNode(false);
    probe.removeAttribute('id');
    probe.removeAttribute('hidden');
    probe.removeAttribute('data-mekhann-product-description-content');
    probe.classList.remove('is-collapsed');
    probe.classList.add('mekhann-product-description__measure');
    probe.setAttribute('aria-hidden', 'true');
    var width = this.content.getBoundingClientRect().width || this.wrapper.getBoundingClientRect().width;
    probe.style.setProperty('position', 'absolute', 'important');
    probe.style.setProperty('visibility', 'hidden', 'important');
    probe.style.setProperty('pointer-events', 'none', 'important');
    probe.style.setProperty('inset', 'auto', 'important');
    probe.style.setProperty('left', '0', 'important');
    probe.style.setProperty('top', '0', 'important');
    probe.style.setProperty('width', width + 'px', 'important');
    probe.style.setProperty('height', 'auto', 'important');
    probe.style.setProperty('max-height', 'none', 'important');
    probe.style.setProperty('overflow', 'visible', 'important');
    probe.style.setProperty('display', 'block', 'important');
    probe.style.setProperty('-webkit-line-clamp', 'unset', 'important');
    probe.style.setProperty('-webkit-box-orient', 'unset', 'important');
    this.wrapper.appendChild(probe);
    return probe;
  };

  DescriptionController.prototype.lineHeight = function (element) {
    var style = window.getComputedStyle(element);
    var lineHeight = parseFloat(style.lineHeight);
    if (!isFinite(lineHeight)) lineHeight = (parseFloat(style.fontSize) || 16) * 1.5;
    return lineHeight;
  };

  DescriptionController.prototype.fullOverflows = function () {
    var probe = this.makeProbe();
    if (this.hasSku) {
      // Preserve the SKU's own 13/20 style, wrapping and paragraph spacing.
      // A detached text-only measurement would count it as 15/23 body text.
      toArray(this.content.childNodes).forEach(function (node) { probe.appendChild(node.cloneNode(true)); });
      toArray(probe.querySelectorAll('[id]')).forEach(function (node) { node.removeAttribute('id'); });
    } else {
      probe.style.setProperty('white-space', 'pre-line', 'important');
      probe.appendChild(document.createTextNode(this.fullMeasureText));
    }
    var overflows = probe.getBoundingClientRect().height > (this.lineHeight(probe) * this.lines) + 1;
    probe.remove();
    return overflows;
  };

  DescriptionController.prototype.excerptText = function () {
    var units = excerptUnits(this.fullText);
    var probe = this.makeProbe();
    var probeToggle = this.toggle.cloneNode(true);
    probeToggle.hidden = false;
    probeToggle.removeAttribute('id');
    probeToggle.setAttribute('tabindex', '-1');
    var probeLabel = probeToggle.querySelector('[data-mekhann-description-label]');
    var probeEllipsis = probeToggle.querySelector('[data-mekhann-description-ellipsis]');
    if (probeLabel) probeLabel.textContent = this.moreLabel;
    else probeToggle.textContent = this.moreLabel;
    if (probeEllipsis) probeEllipsis.hidden = true;
    var lineLimit = this.lineHeight(probe) * this.lines + 1;

    function fits(count) {
      probe.replaceChildren();
      var span = document.createElement('span');
      span.setAttribute('data-mekhann-product-description-excerpt', '');
      span.appendChild(document.createTextNode(units.slice(0, count).join('').trimEnd() + '\u2026 '));
      span.appendChild(probeToggle);
      probe.appendChild(span);
      return probe.getBoundingClientRect().height <= lineLimit;
    }

    var low = 0;
    var high = units.length;
    while (low < high) {
      var middle = Math.ceil((low + high) / 2);
      if (fits(middle)) low = middle;
      else high = middle - 1;
    }
    probe.remove();
    return units.slice(0, low).join('').trimEnd();
  };

  DescriptionController.prototype.renderCollapsed = function () {
    var restoreFocus = document.activeElement === this.toggle;
    this.wrapper.classList.remove('is-expanded');
    var excerptText = this.excerptText();
    var excerpt = document.createElement('span');
    excerpt.setAttribute('data-mekhann-product-description-excerpt', '');
    excerpt.appendChild(document.createTextNode((excerptText || '') + '\u2026 '));
    this.toggle.hidden = false;
    this.setToggleLabel(this.moreLabel);
    this.toggle.setAttribute('aria-expanded', 'false');
    excerpt.appendChild(this.toggle);
    if (this.excerpt) this.excerpt.remove();
    this.excerpt = excerpt;
    this.wrapper.insertBefore(excerpt, this.content);
    this.hideOriginal();
    this.content.classList.add('is-collapsed');
    this.wrapper.classList.remove('is-expanded');
    this.wrapper.classList.add('is-overflowing', 'is-collapsed');
    this.expanded = false;
    if (restoreFocus) {
      window.requestAnimationFrame(function () { this.toggle.focus({ preventScroll: true }); }.bind(this));
    }
  };

  DescriptionController.prototype.renderExpanded = function () {
    var restoreFocus = document.activeElement === this.toggle;
    this.showOriginal();
    this.content.classList.remove('is-collapsed');
    this.toggle.hidden = false;
    this.setToggleLabel(this.lessLabel);
    this.toggle.setAttribute('aria-expanded', 'true');
    this.wrapper.appendChild(this.toggle);
    this.wrapper.classList.remove('is-collapsed');
    this.wrapper.classList.add('is-overflowing', 'is-expanded');
    this.expanded = true;
    if (restoreFocus) {
      window.requestAnimationFrame(function () { this.toggle.focus({ preventScroll: true }); }.bind(this));
    }
  };

  DescriptionController.prototype.renderUnclamped = function () {
    this.showOriginal();
    this.content.classList.remove('is-collapsed');
    this.toggle.hidden = true;
    this.toggle.setAttribute('aria-expanded', 'false');
    this.wrapper.appendChild(this.toggle);
    this.wrapper.classList.remove('is-collapsed', 'is-expanded', 'is-overflowing');
    // A short/blank new SKU can stop overflowing. Preserve the user's expanded
    // preference if a later variant needs the disclosure again.
    if (!this.hasSku) this.expanded = false;
  };

  DescriptionController.prototype.measure = function () {
    if (this.destroyed || !this.content || !this.toggle || !this.wrapper.isConnected) return;
    this.lastWidth = Math.round(this.wrapper.getBoundingClientRect().width * 10) / 10;
    var overflowing = this.fullOverflows();
    if (!overflowing) this.renderUnclamped();
    else if (this.expanded) this.renderExpanded();
    else this.renderCollapsed();
  };

  DescriptionController.prototype.queueMeasure = function () {
    if (this.destroyed) return;
    window.cancelAnimationFrame(this.resizeFrame);
    this.resizeFrame = window.requestAnimationFrame(this.measure.bind(this));
  };

  DescriptionController.prototype.onToggle = function () {
    if (this.expanded) {
      this.expanded = false;
      this.measure();
    } else {
      this.renderExpanded();
    }
  };

  DescriptionController.prototype.destroy = function () {
    this.destroyed = true;
    window.cancelAnimationFrame(this.resizeFrame);
    window.removeEventListener('resize', this.boundResize);
    if (this.resizeObserver) this.resizeObserver.disconnect();
    if (this.toggle) this.toggle.removeEventListener('click', this.boundToggle);
    if (this.content && this.toggle) {
      this.showOriginal();
      this.content.classList.remove('is-collapsed');
      this.setToggleLabel(this.moreLabel);
      this.toggle.hidden = true;
      this.toggle.setAttribute('aria-expanded', 'false');
      this.wrapper.appendChild(this.toggle);
      this.wrapper.classList.remove('is-collapsed', 'is-expanded', 'is-overflowing');
    }
  };

  function StoreAvailabilityController(holder) {
    this.holder = holder;
    this.abortController = null;
    this.requestToken = 0;
    this.hasConfirmedContent = Boolean(holder.querySelector('.mekhann-store-availability__location'));
    this.confirmedVariantId = this.hasConfirmedContent ? String(holder.dataset.currentVariantId || '') : '';
    holder.setAttribute('aria-live', 'polite');
  }

  StoreAvailabilityController.prototype.renderStatus = function (label) {
    var text = normaliseText(label);
    this.holder.replaceChildren();
    if (!text) {
      this.holder.hidden = true;
      return false;
    }
    var status = document.createElement('p');
    status.className = 'mekhann-store-availability-inline__status';
    status.setAttribute('data-mekhann-store-status', '');
    status.textContent = text;
    this.holder.appendChild(status);
    this.holder.hidden = false;
    return true;
  };

  StoreAvailabilityController.prototype.endpoint = function (variantId) {
    var shopifyRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    var root = new URL(this.holder.dataset.baseUrl || shopifyRoot || '/', window.location.origin);
    root.pathname = (root.pathname.replace(/\/+$/, '') + '/variants/' + encodeURIComponent(variantId) + '/').replace(/\/{2,}/g, '/');
    root.search = 'section_id=store-availability';
    root.hash = '';
    return root.toString();
  };

  StoreAvailabilityController.prototype.locationFrom = function (source) {
    var info = source.querySelector('.store-availability__info');
    if (!info) return null;
    var strongSource = info.querySelector('strong');
    var name = normaliseText(strongSource && strongSource.textContent);
    var statusSource = toArray(info.querySelectorAll('p.store-availability__small')).find(function (node) {
      return !node.classList.contains('store-availability__small--link');
    });
    var status = normaliseText(statusSource && statusSource.textContent);
    if (source.querySelector('.icon-out-of-stock') && this.holder.dataset.unavailableLabel) {
      status = normaliseText(this.holder.dataset.unavailableLabel);
    }
    var addressSource = toArray(info.querySelectorAll('div.store-availability__small')).find(function (node) {
      return !node.classList.contains('store-availability__info');
    });
    var actionSource = addressSource && addressSource.querySelector('.mekhann-store-availability__actions');
    var address = addressSource && addressSource.cloneNode(true);
    if (address) {
      toArray(address.querySelectorAll('.mekhann-store-availability__actions, svg, button')).forEach(function (node) { node.remove(); });
      toArray(address.querySelectorAll('[id]')).forEach(function (node) { node.removeAttribute('id'); });
      address.className = 'mekhann-store-availability__address';
      if (!normaliseText(address.textContent)) address = null;
    }
    if (!name && !status && !address) return null;

    var row = document.createElement('div');
    row.className = 'mekhann-store-availability__location';
    if (name) {
      var heading = document.createElement('p');
      heading.className = 'mekhann-store-availability__name';
      var strong = document.createElement('strong');
      strong.textContent = name;
      heading.appendChild(strong);
      row.appendChild(heading);
    }
    if (status) {
      var statusNode = document.createElement('p');
      statusNode.className = 'mekhann-store-availability__status';
      statusNode.textContent = status;
      row.appendChild(statusNode);
    }
    if (address) row.appendChild(address);

    var links = actionSource ? toArray(actionSource.querySelectorAll('a[href]')) : [];
    var actions = document.createElement('p');
    actions.className = 'mekhann-store-availability__actions';
    links.forEach(function (sourceLink) {
      var href = (sourceLink.getAttribute('href') || '').trim();
      if (!href || href === '#') return;
      var link = document.createElement('a');
      link.href = href;
      var phone = href.indexOf('tel:') === 0;
      var label = phone ? this.holder.dataset.phoneLabel : this.holder.dataset.directionsLabel;
      link.textContent = normaliseText(label || sourceLink.textContent);
      if (!link.textContent) return;
      if (!phone) {
        link.target = '_blank';
        link.rel = 'noopener';
      }
      actions.appendChild(link);
    }, this);
    if (actions.children.length) row.appendChild(actions);
    return row;
  };

  StoreAvailabilityController.prototype.parse = function (html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var drawer = doc.querySelector('#StoreAvailabilityDrawer');
    var rows = drawer ? drawer.querySelectorAll('.drawer__scrollable .store-availability') : [];
    if (!rows.length) rows = doc.querySelectorAll('[data-section-type="store-availability"] > .store-availability');
    var fragment = document.createDocumentFragment();
    toArray(rows).forEach(function (source) {
      var row = this.locationFrom(source);
      if (row) fragment.appendChild(row);
    }, this);
    return fragment;
  };

  StoreAvailabilityController.prototype.update = function (variantId) {
    var holder = this.holder;
    var token = ++this.requestToken;
    if (this.abortController) this.abortController.abort();
    this.abortController = window.AbortController ? new AbortController() : null;
    if (!variantId) {
      holder.replaceChildren();
      holder.hidden = true;
      holder.removeAttribute('aria-busy');
      this.hasConfirmedContent = false;
      this.confirmedVariantId = '';
      return;
    }

    var requestedVariantId = String(variantId);
    if (this.confirmedVariantId !== requestedVariantId) {
      this.hasConfirmedContent = false;
      this.confirmedVariantId = '';
      this.renderStatus(holder.dataset.loadingLabel || 'Checking store availability…');
    }
    holder.setAttribute('aria-busy', 'true');
    if (this.hasConfirmedContent) holder.hidden = false;
    var options = { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } };
    if (this.abortController) options.signal = this.abortController.signal;
    fetch(this.endpoint(variantId), options)
      .then(function (response) {
        if (!response.ok) throw new Error('Store availability request failed: ' + response.status);
        return response.text();
      })
      .then(function (html) {
        if (token !== this.requestToken || !holder.isConnected) return;
        var fragment = this.parse(html);
        var hasRows = Boolean(fragment.childNodes.length);
        if (hasRows) {
          holder.replaceChildren(fragment);
          holder.hidden = false;
          this.hasConfirmedContent = true;
          this.confirmedVariantId = requestedVariantId;
          return;
        }

        var unavailableLabel = normaliseText(holder.dataset.unavailableLabel);
        this.hasConfirmedContent = this.renderStatus(unavailableLabel);
        this.confirmedVariantId = this.hasConfirmedContent ? requestedVariantId : '';
      }.bind(this))
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        if (token !== this.requestToken) return;
        if (!this.hasConfirmedContent) {
          this.hasConfirmedContent = this.renderStatus(holder.dataset.errorLabel);
          this.confirmedVariantId = this.hasConfirmedContent ? requestedVariantId : '';
        }
      }.bind(this))
      .finally(function () {
        if (token === this.requestToken) holder.removeAttribute('aria-busy');
      }.bind(this));
  };

  StoreAvailabilityController.prototype.destroy = function () {
    this.requestToken += 1;
    if (this.abortController) this.abortController.abort();
    this.holder.removeAttribute('aria-busy');
  };

  function PdpController(section) {
    this.section = section;
    this.descriptions = [];
    this.stores = [];
    this.collapsibleTimer = 0;
    this.boundVariantChange = this.onVariantChange.bind(this);
    this.boundSectionClick = this.onSectionClick.bind(this);
    section.addEventListener('variantChange', this.boundVariantChange);
    section.addEventListener('click', this.boundSectionClick, true);
    toArray(section.querySelectorAll('[data-mekhann-product-description]')).forEach(function (wrapper) {
      var controller = new DescriptionController(wrapper);
      if (controller.content && controller.toggle) this.descriptions.push(controller);
    }, this);
    toArray(section.querySelectorAll('[data-mekhann-store-availability]')).forEach(function (holder) {
      this.stores.push(new StoreAvailabilityController(holder));
    }, this);
    this.onVariantChange({ detail: { variant: this.currentVariant() } });
  }

  PdpController.prototype.currentVariant = function () {
    var select = this.section.querySelector('[data-product-select]');
    var id = select && select.value;
    var json = this.section.querySelector('[data-variant-json]');
    if (!id || !json) return id ? { id: id } : null;
    try {
      return JSON.parse(json.value || json.textContent).find(function (variant) {
        return String(variant.id) === String(id);
      }) || { id: id };
    } catch (error) {
      return { id: id };
    }
  };

  PdpController.prototype.variantTitle = function (variant) {
    if (variant && variant.title && variant.title !== 'Default Title') return variant.title;
    return toArray(this.section.querySelectorAll('[data-variant-input]:checked'))
      .map(function (input) { return input.value; })
      .filter(Boolean)
      .join(' / ') || 'Default';
  };

  PdpController.prototype.updateAssurance = function (variant) {
    toArray(this.section.querySelectorAll('[data-mekhann-dispatch]')).forEach(function (dispatch) {
      dispatch.hidden = !variant || variant.available === false;
    });
  };

  PdpController.prototype.updateSku = function (variant) {
    var sku = String(variant && variant.sku || '').trim();
    toArray(this.section.querySelectorAll('[data-mekhann-sku]')).forEach(function (wrapper) {
      var value = wrapper.querySelector('[data-sku]');
      if (value) value.textContent = sku;
      wrapper.hidden = !sku;
    });
    this.descriptions.forEach(function (description) { description.refreshSource(); });
  };

  PdpController.prototype.updateAdvisor = function (variant) {
    var variantId = variant && variant.id;
    var productUrl = new URL(this.section.dataset.productUrl || window.location.pathname, window.location.origin);
    if (variantId) productUrl.searchParams.set('variant', variantId);
    var title = this.variantTitle(variant);
    toArray(this.section.querySelectorAll('[data-mekhann-advisor-open]')).forEach(function (trigger) {
      trigger.dataset.mekhannAdvisorVariant = title;
      trigger.dataset.mekhannAdvisorUrl = productUrl.toString();
    });
  };

  PdpController.prototype.updateDimensions = function (variant) {
    var variantId = variant && variant.id;
    var variantTitle = this.variantTitle(variant).toLowerCase();
    toArray(this.section.querySelectorAll('[data-mekhann-size-fitting], [data-mekhann-lampshade-details]')).forEach(function (owner) {
      var output = owner.querySelector('[data-mekhann-size-dimensions], [data-mekhann-selected-dimensions]');
      if (!output) return;
      var source = variantId && owner.querySelector('[data-mekhann-variant-dimensions][data-variant-id="' + cssEscape(variantId) + '"]');
      var value = normaliseMultiline(source && source.textContent);
      if (!value && variantTitle.indexOf('medium') !== -1) value = owner.dataset.dimensionsMedium || '';
      if (!value && variantTitle.indexOf('large') !== -1) value = owner.dataset.dimensionsLarge || '';
      value = dimensionsForSize(value || owner.dataset.sharedDimensions || owner.dataset.dimensionsFallback, variantTitle);
      setMultilineText(output, value);
      output.hidden = !value;
    });
  };

  PdpController.prototype.onVariantChange = function (event) {
    var hasVariantDetail = Boolean(event && event.detail &&
      Object.prototype.hasOwnProperty.call(event.detail, 'variant'));
    var variant = hasVariantDetail ? event.detail.variant : this.currentVariant();
    this.updateSku(variant);
    this.updateAssurance(variant);
    this.updateAdvisor(variant);
    this.updateDimensions(variant);
    var variantId = variant && variant.id;
    this.stores.forEach(function (store) { store.update(variantId); });
  };

  PdpController.prototype.onSectionClick = function (event) {
    if (!event.target.closest('.collapsible-trigger')) return;
    window.clearTimeout(this.collapsibleTimer);
    this.collapsibleTimer = window.setTimeout(function () {
      this.descriptions.forEach(function (description) { description.queueMeasure(); });
    }.bind(this), 360);
  };

  PdpController.prototype.destroy = function () {
    window.clearTimeout(this.collapsibleTimer);
    this.section.removeEventListener('variantChange', this.boundVariantChange);
    this.section.removeEventListener('click', this.boundSectionClick, true);
    this.descriptions.forEach(function (description) { description.destroy(); });
    this.stores.forEach(function (store) { store.destroy(); });
    this.descriptions = [];
    this.stores = [];
  };

  function initSection(section) {
    if (!section || !section.matches(SECTION_SELECTOR)) return;
    if (section.mekhannPdpV218Controller) return;
    section.mekhannPdpV218Controller = new PdpController(section);
  }

  function destroyScope(scope) {
    var sections = [];
    if (scope && scope.matches && scope.matches(SECTION_SELECTOR)) sections.push(scope);
    if (scope && scope.querySelectorAll) sections = sections.concat(toArray(scope.querySelectorAll(SECTION_SELECTOR)));
    sections.forEach(function (section) {
      if (section.mekhannPdpV218Controller) {
        section.mekhannPdpV218Controller.destroy();
        section.mekhannPdpV218Controller = null;
      }
    });

    var legacyLampshadeSections = [];
    if (scope && scope.matches && scope.matches(LEGACY_LAMPSHADE_SELECTOR)) legacyLampshadeSections.push(scope);
    if (scope && scope.querySelectorAll) {
      legacyLampshadeSections = legacyLampshadeSections.concat(toArray(scope.querySelectorAll(LEGACY_LAMPSHADE_SELECTOR)));
    }
    legacyLampshadeSections.forEach(function (section) {
      if (section.mekhannLegacyLampshadeV218Controller) {
        section.mekhannLegacyLampshadeV218Controller.destroy();
        section.mekhannLegacyLampshadeV218Controller = null;
      }
    });

    var legacySections = [];
    if (scope && scope.matches && scope.matches('.product-section')) legacySections.push(scope);
    if (scope && scope.querySelectorAll) {
      legacySections = legacySections.concat(toArray(scope.querySelectorAll('.product-section')));
    }
    legacySections.forEach(unbindLegacyAdvisor);
  }

  function initScope(scope) {
    initAdvisorHub();
    var root = scope && scope.querySelectorAll ? scope : document;
    var allSections = [];
    if (root.matches && root.matches('.product-section')) allSections.push(root);
    allSections = allSections.concat(toArray(root.querySelectorAll('.product-section')));
    allSections.forEach(bindLegacyAdvisor);
    if (root.matches && root.matches(LEGACY_LAMPSHADE_SELECTOR)) initLegacyLampshadeSection(root);
    toArray(root.querySelectorAll(LEGACY_LAMPSHADE_SELECTOR)).forEach(initLegacyLampshadeSection);
    if (root.matches && root.matches(SECTION_SELECTOR)) initSection(root);
    toArray(root.querySelectorAll(SECTION_SELECTOR)).forEach(initSection);
  }

  function initSiteNotice() {
    var notice = document.querySelector('[data-mekhann-site-notice]');
    if (!notice || notice.dataset.mekhannV218Bound === 'true') return;
    notice.dataset.mekhannV218Bound = 'true';
    var message = notice.querySelector('[data-mekhann-site-notice-message]');
    var cartLink = notice.querySelector('[data-mekhann-site-notice-cart]');
    var close = notice.querySelector('[data-mekhann-site-notice-close]');
    function hideNotice() {
      window.clearTimeout(noticeTimer);
      window.clearTimeout(noticeHideTimer);
      notice.classList.remove('is-visible');
      noticeHideTimer = window.setTimeout(function () { notice.hidden = true; }, 180);
    }
    document.addEventListener('mekhann:notice', function (event) {
      var detail = event.detail || {};
      if (message) message.textContent = detail.message || 'We could not complete that request. Please try again.';
      if (cartLink) cartLink.hidden = detail.showCartLink === false;
      window.clearTimeout(noticeTimer);
      window.clearTimeout(noticeHideTimer);
      notice.hidden = false;
      window.requestAnimationFrame(function () { notice.classList.add('is-visible'); });
      noticeTimer = window.setTimeout(hideNotice, 8000);
    });
    if (close) close.addEventListener('click', hideNotice);
  }

  function init() {
    initSiteNotice();
    initScope(document);
    document.addEventListener('quickview:loaded', function (event) {
      var productId = event.detail && event.detail.productId;
      var modal = productId && document.getElementById('QuickShopModal-' + productId);
      initScope(modal || document);
    });
    document.addEventListener('shopify:section:load', function (event) { initScope(event.target); });
    document.addEventListener('shopify:section:unload', function (event) { destroyScope(event.target); });
    document.addEventListener('shopify:block:select', function (event) {
      var section = event.target && event.target.closest && event.target.closest(SECTION_SELECTOR);
      if (section && !section.mekhannPdpV218Controller) initSection(section);
      var selectedAccordion = event.target && event.target.closest && event.target.closest(
        '.product-block--mekhann-accordion, .product-block--mekhann-store-collection'
      );
      var trigger = selectedAccordion && selectedAccordion.querySelector('.collapsible-trigger');
      if (
        section &&
        selectedAccordion &&
        section.contains(selectedAccordion) &&
        trigger &&
        !trigger.classList.contains('is-open')
      ) trigger.click();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
